<template>
  <div class="summary">
    <h2 class="title is-4">Summary</h2>
    <div class="mb-2">
      <h3 class="title is-6 mb-1">Vehicle Insurance ({{ paymentInterval(true) }})</h3>
    </div>
    <hr />
    <div v-if="!isAltFlow" class="columns is-mobile mb-1">
        <div class="column is-8">
          <span v-if="isAltFlow">New {{ paymentInterval() }} payment</span>
          <span v-else>Subtotal (NZD, includes GST)</span>
        </div>
        <div class="column has-text-right">
          <span>{{ getPremiumIncDiscount | toCurrency }}</span>
        </div>
    </div>

    <div class="columns is-mobile mb-1" v-if="answers[getStep('Vehicle.Quote')].vehicle_quote_discount_raw && !isAltFlow">
      <div class="column is-8">
        <span>
          <InlineText
            label="Discount"
            tooltip="Discounts are applied to the insurer premium component before any levies or fees are factored in.  The discount may reduce or not apply if the insurer premium is below our minimum policy charge."
        />
        </span>
      </div>
      <div class="column has-text-right has-text-primary">
        <span>-{{ answers[getStep('Vehicle.Quote')].vehicle_quote_discount_raw | toCurrency }}</span>
      </div>
    </div>

    <div v-if="isAltFlow" class="columns is-mobile mb-1">
      <div class="column is-8">
        <span>Adjustment amount</span>
      </div>
      <div class="column has-text-right">
        <template v-if="parseFloat(answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw) >= 0">
          <span>{{ answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw | toCurrency }}</span>
        </template>
        <template v-else>
          <span>-{{  answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw * -1 | toCurrency }}</span>
        </template>
      </div>
    </div>

    <hr />
    <div class="mb-2">
      <div class="columns is-mobile mb-1 title is-6">
        <div class="column">
          <template v-if="isAltFlow">
            <template v-if="answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw >= 0">
              To Pay Today
            </template>
            <template v-else>
              Refund
            </template>
          </template>
          <template v-else>Total</template>
        </div>
        <div class="column has-text-right">
          NZD
          <template v-if="isAltFlow">
            <template v-if="answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw >= 0">
              {{ (answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw) | toCurrency }}
            </template>
            <template v-else>
              {{ answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw * -1 | toCurrency }}
            </template>
          </template>
          <template v-else>
            {{ answers[getStep('Vehicle.Quote')].vehicle_quote_premium_raw | toCurrency }}
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fulltextDate } from '@/helpers/dateHelper.js'
import { toCurrency } from '@/helpers/currencyHelper.js'

export default {
  components: {

  },
  methods: {
    fulltextDate,
    toCurrency
  },
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers', answerLabel: 'getAnswerLabel', getStep: 'getStep', isAltFlow: 'isAltFlow', paymentInterval: 'getPaymentInterval' }),
    getPremiumIncDiscount: function(){
      const discount = this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_discount_raw ? parseFloat(this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_discount_raw) : 0;
      return parseFloat(this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw) + discount;
    }
  },
  data () {
    return {
    }
  },
  name: 'initio-summary-payment'
}

</script>

<style scoped lang="scss">

</style>